export default __webpack_public_path__ + "static/media/99.df33d39d.jpg";